import React from "react";
import { object, array } from "prop-types";

import ProjectFundingPartner from "../../molecules/project-funding-partner";
import PeopleTeamRow from "../../rows/people-team";
import AlsoRead from "../../molecules/also-read";

import "./project-story-footer.m.css";

const ProjectStoryFooter = ({ story, linkedStories }) => {
  const sectionName = story.sections && story.sections[0] ? story.sections[0].name : "";
  const isPartnershipsSection = sectionName === "Partnerships";

  const filteredAuthors = isPartnershipsSection
    ? (story.authors || []).filter(author => author.name !== "The NCF Community")
    : story.authors;

  return (
    <div styleName="wrapper">
      {filteredAuthors && filteredAuthors.length > 0 && <PeopleTeamRow authors={filteredAuthors} />}
      <ProjectFundingPartner story={story} type="partners" />
      <ProjectFundingPartner story={story} type="funding" />
      <AlsoRead linkedStories={linkedStories} />
    </div>
  );
};

ProjectStoryFooter.propTypes = {
  story: object,
  linkedStories: array
};

export default ProjectStoryFooter;
